import React from "react";

import { Avatar, AvatarImage, Col, Icon, Row } from "components";

import { CoursePlan } from "pages/app/courses/components/Plan";

export const CourseDetails = ({ course, courseStarted, handleSelectModule, t }) => (
  <section className="container content mini">
    <Row>
      <Col>
        <h2 className="section-heading">{t("courseOverview.aboutThisCourse")}</h2>
        <div dangerouslySetInnerHTML={{ __html: course.description }} />
      </Col>
    </Row>
    <Row>
      <Col>
        <h4>{t("courseOverview.whatYouWillLearn")}</h4>
        <ul className="klim-list">
          {course.learnings
            .filter((line) => line)
            .map((learning, i) => (
              <li key={i}>
                <Icon iconName="tabler/circle-check"></Icon>
                <span>{learning}</span>
              </li>
            ))}
        </ul>
      </Col>
    </Row>
    <Row>
      <Col>
        <h2 className="section-heading">{t("courseOverview.meetYourTeacher")}</h2>
        <div className="teacher-details">
          {!course.teacherImage || course.teacherImage === "" ? (
            <Avatar size="m" name={course.teacherName} />
          ) : (
            <AvatarImage size="m" image={course.teacherImage} />
          )}
          <h4>{course.teacherName}</h4>
        </div>
        <p className="teacher-description">{course.teacherDescription}</p>
      </Col>
    </Row>
    <Row>
      <Col>
        <h2 className="section-heading">{t("courseOverview.requirements")}</h2>
        <ul className="klim-bullet-list">
          {course.requirements
            .filter((line) => line)
            .map((requirement, i) => (
              <li key={i}>{requirement}</li>
            ))}
        </ul>
      </Col>
    </Row>
    {!courseStarted && <CoursePlan course={course} courseStarted={courseStarted} completedModules={[]} onModuleSelect={(v) => handleSelectModule(v)} />}
  </section>
);
